import * as d3 from 'd3';
import Holidays from 'date-holidays';
// daysBetween gibt es hier lokal auch - die arbeitet aber auf Date, nimmt den
// Absolutbetrag und liefert mindestens 7. Fuer Pausenlaengen deshalb die
// vorzeichenbehaftete ISO-Variante unter eigenem Namen.
import { toIso, toGerman, addDays, daysBetween as daysBetweenIso } from '@/utils/dateUtils';
import { evaluateFilter } from './resourceFilter';
import mitt from 'mitt'

export const bus = mitt()

// Die eine Kategorie, deren Buchungen ins Hauptprojekt gespiegelt werden.
// Kommt wie die Liste aus Project::DERIVING_CATEGORY.
export const DERIVING_CATEGORY =
  document.getElementById('app')?.dataset.derivingCategory ?? null

export const dayMs = 1000 * 60 * 60 * 24;
export const buffer = 5;
export const printHeaderHeight = 40;
export const rowHeight = 36;

export function cleanx(x, d) {
  return Math.round(x(d))
}
export function getWidthPerDay(isprintView, zoomWidthPerDay) {

  if (zoomWidthPerDay) {
     return zoomWidthPerDay
  } else {
     return isprintView ? 21 : 60;
  }
}

export function getRowHeight(isprintView) {
   return isprintView ? 25 : 36;
}

export const germanDays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

export function snap(val, isprintView, zoomWidthPerDay) {
  let widthPerDay = getWidthPerDay(isprintView, zoomWidthPerDay)
	return Math.round(val / widthPerDay) * widthPerDay
}

export function nDaysLater(date, n) {
  const result = new Date(date);
  result.setDate(result.getDate() + n);
  return result;
}

export function nextDay(date) {
  return nDaysLater(date, 1);
}

export function isLastDayOfMonth(date) {
  return nextDay(date).getDate() === 1;
}

// Bekommt ein Date auf UTC-Mitternacht (fromIso / Achsen-Raster), deshalb
// getUTCDay. Mit getDay traf es westlich von Greenwich den Vortag (TIM-36).
export function isWeekstart(date) {
  return date.getUTCDay() === 1;
}

export function getGermanWeekRange(inputDate) {
  const date = new Date(inputDate)

  // normalize time (optional but usually helpful)
  date.setHours(0, 0, 0, 0)

  // JS: Sunday = 0, Monday = 1, ... Saturday = 6
  const day = date.getDay()

  // convert so Monday = 0 ... Sunday = 6
  const diffToMonday = (day + 6) % 7

  const monday = new Date(date)
  monday.setDate(date.getDate() - diffToMonday)

  const sunday = new Date(monday)
  sunday.setDate(monday.getDate() + 6)

  return { startOfWeek: monday, endOfWeek: sunday }
}

export function getMonthRange(inputDate) {
  const date = new Date(inputDate)

  const startOfMonth = new Date(
    date.getFullYear(),
    date.getMonth(),
    1
  )

  const endOfMonth = new Date(
    date.getFullYear(),
    date.getMonth() + 1,
    0
  )

  return {
    startOfMonth,
    endOfMonth
  }
}

export function getQuarterRange(inputDate) {
  const date = new Date(inputDate)

  const quarter = Math.floor(date.getMonth() / 3)

  const startMonth = quarter * 3
  const endMonth = startMonth + 2

  const startOfQuarter = new Date(
    date.getFullYear(),
    startMonth,
    1
  )

  const endOfQuarter = new Date(
    date.getFullYear(),
    endMonth + 1,
    0
  )

  return {
    startOfQuarter,
    endOfQuarter
  }
}

export function getHalfYearRange(inputDate) {
  const date = new Date(inputDate)

  const month = date.getMonth()

  // First half: Jan-Jun
  // Second half: Jul-Dec
  const startMonth = month < 6 ? 0 : 6
  const endMonth = startMonth + 5

  const startDate = new Date(
    date.getFullYear(),
    startMonth,
    1
  )

  const endDate = new Date(
    date.getFullYear(),
    endMonth + 1,
    0
  )


  return {
    startOfHalf: startDate,
    endOfHalf: endDate
  }

}

export function isFirstFullWorkWeek(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = d.getMonth();

  // 1. Find the first day of this month
  const firstDayOfMonth = new Date(year, month, 1);
  
  // 2. Find the first Monday of this month
  // getDay() is 0 for Sunday, 1 for Monday...
  let firstMonday = new Date(year, month, 1);
  while (firstMonday.getDay() !== 1) {
    firstMonday.setDate(firstMonday.getDate() + 1);
  }

  // 3. Determine if the week starting at 'firstMonday' is fully contained.
  // A week is fully contained if its Monday is the 1st of the month.
  // If the first Monday is the 2nd through 7th, we must check if 
  // the previous days (the 1st, etc.) belonged to the previous week.
  
  let firstFullWeekMonday;
  
  if (firstDayOfMonth.getDay() === 1) {
    // If the 1st is a Monday, the week of the 1st is the first full week.
    firstFullWeekMonday = firstDayOfMonth;
  } else {
    // If the 1st is NOT a Monday (Tue-Sun), the week containing the 1st 
    // started in the previous month. Therefore, the very first 
    // Monday of THIS month starts the first fully contained week.
    firstFullWeekMonday = firstMonday;
  }

  // 4. Compare the input date to our calculated First Full Week Monday
  return d.getTime() === firstFullWeekMonday.getTime();
}

export function isUserBooking(p, u, b) {
   return b.user_id === u.id
}

// Überschneidet die Entität (Buchung ODER Projekt) den Zeitraum? Alles ISO,
// Vergleich lexikografisch = chronologisch.
export function is_bookable(b, selectedDays) {
  if (!b.start || !b.end) {
    return false;
  }
  const first = selectedDays[0];
  const last  = selectedDays.at(-1);
  return b.end >= first && b.start <= last;
}

// Die Abschnitte, nach denen sich eine Zeile richtet.
//
// Ein Leistungsbereich laeuft nur, solange das Hauptprojekt laeuft - dessen
// Pausen sind damit auch seine (TIM-73). Deshalb erbt er sie, begrenzt auf den
// eigenen Zeitraum. Fuer Hauptprojekte und alle uebrigen Kategorien bleibt es
// bei den eigenen Abschnitten: eine Unterkunft darf ueber eine Pause hinweg
// laufen.
export function effectivePeriods(p, projects = null) {
  const eigene = projectPeriods(p);
  if (!p?.parent_id || p.category !== DERIVING_CATEGORY || !projects) return eigene;

  const haupt = projects.find(x => Number(x.id) === Number(p.parent_id));
  if (!haupt) return eigene;

  return projectPeriods(haupt)
    .map(a => ({ start: a.start > p.start ? a.start : p.start,
                 end:   a.end   < p.end   ? a.end   : p.end }))
    .filter(a => a.start <= a.end);
}

// Faellt die Buchung in einen Abschnitt des Projekts? Bewusst gegen die
// Abschnitte und nicht gegen die aeussere Klammer: waehrend einer Pause ruht das
// Projekt, dort soll auch keine Fremdbuchung erscheinen - sonst zeigt die
// Personenzeile Balken, wo die Projektzeile darueber leer ist.
export function isBookingInProject(p, b, projects = null) {
  return effectivePeriods(p, projects).some(pd => is_bookable(b, [pd.start, pd.end]));
}

export function prepTask(pid2pnames, p, u, b, alleBookings = null) {
  let inproject = b.project_id === p.id
  let pname = pid2pnames[b.project_id.toString()]
  let label = u.short + (inproject ?  "" : ">" + pname)

  // Abgeleitete Buchung: sie traegt den Namen des Unterprojekts, aus dem sie
  // stammt - so ist zu sehen, WOHER sie kommt, nicht nur DASS sie abgeleitet
  // ist (Entwurf Bjoern, TIM-74).
  // Nur in ihrem eigenen Projekt wird eine abgeleitete Buchung als Linie mit
  // Anker gezeichnet. Anderswo ist sie eine gewoehnliche Fremdbuchung - dort
  // sagte die Sonderdarstellung "kommt aus einem Bereich" ueber eine Zeile, mit
  // der dieser Bereich nichts zu tun hat.
  const abgeleitet = !!b.derived_from_id && inproject

  let herkunft = null
  if (abgeleitet && alleBookings) {
    const quelle = alleBookings.find(x => Number(x.id) === Number(b.derived_from_id))
    if (quelle) herkunft = pid2pnames[quelle.project_id.toString()] ?? null
  }

  return {id: b.id,
	    start: b.start,
	    end: b.end,
		  color: p.color,
		  pname: pname,
      project_id: b.project_id,
		  inproject: inproject,
      derived: abgeleitet,
      derivedFrom: herkunft,
      // Wird gebraucht, um von der abgeleiteten Buchung zu ihrer Quelle zu
      // springen. Fehlte hier, weshalb der Klick ins Leere lief.
      derived_from_id: b.derived_from_id,
      // Die Herkunft steckt nicht mehr in der Beschriftung: eine abgeleitete
      // Buchung wird eigens gezeichnet und traegt ihren Quellnamen ueber der
      // Linie (Entwurf Bjoern, TIM-74). In der Beschriftung sah sie aus wie
      // eine Fremdbuchung - beides war "Kuerzel plus fremder Projektname".
      label: label
  };
}

// Rand API -> Modell: start/end bleiben ISO ("yyyy-mm-dd", identisch zu Rails t.date).
// Ein `Date` entsteht erst an der D3-Grenze über fromIso().
export function prepBooking(b) {
  return {id: b.id, start: b.start, end: b.end, user_id: b.user_id, project_id: b.project_id,
          // Abgeleitete Buchung (TIM-73): leer = eigenstaendig, wie bisher.
          derived_from_id: b.derived_from_id }
}

export function prepProject(p) {
  return {id: p.id, name: p.name, description: p.description, status: p.status,
          start: p.start, end: p.end, color: p.color, altname: p.altname,
          // Unterprojekte (TIM-73): parent_id leer = eigenstaendiges Projekt.
          parent_id: p.parent_id, category: p.category,
          // Zeitabschnitte (TIM-38). start/end bleiben die aeussere Klammer;
          // Projekte ohne Abschnitte (Altbestand) verhalten sich wie eines.
          periods: projectPeriods(p) }
}

// Die Abschnitte eines Projekts als [{start, end}] in ISO, chronologisch.
// Faellt auf den Projektzeitraum zurueck, solange keine Abschnitte vorliegen.
export function projectPeriods(p) {
  const raw = Array.isArray(p.periods) ? p.periods : []
  const periods = raw
    .filter(r => r && r.start && r.end)
    .map(r => ({ start: r.start, end: r.end }))
    .sort((a, b) => a.start.localeCompare(b.start))
  if (periods.length > 0) return periods
  return p.start && p.end ? [{ start: p.start, end: p.end }] : []
}

export function getBavariaHolidaysBetween(startDate, endDate) {
  const hd = new Holidays('DE', 'BY'); // Germany, Bavaria
  const holidays = [];

  for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year++) {
    const yearHolidays = hd.getHolidays(year);
    yearHolidays.forEach(h => {
      const d = new Date(h.date);
      if (h.type === "public" && d >= startDate && d <= endDate) {
        holidays.push({ name: h.name, date: d });
      }
    });
  }

  return holidays;
}

export function createAxisLine(zoomWidthPerDay, startDate, endDate, data, format, getEnd = null, withWeekends = false, withHolidays = false, isprintView = false, extraClassLine = "", extraClassCell = "") {
  const line = document.createElement("div");
  const holidays = getBavariaHolidaysBetween(startDate, endDate);
  const widthPerDay = getWidthPerDay(isprintView, zoomWidthPerDay);

  line.className = "time-axis-line" + extraClassLine + (isprintView ? " printview" : "");

  data.forEach((d, i) => {
    // 1. Determine the logical start and end of THIS specific cell
    let cellStart = d;
    let cellEnd = getEnd ? getEnd(data, i) : d3.utcDay.offset(d, 1);

    // 2. CLIPPING: Ensure the cell doesn't go outside the axis boundaries
    // If the week starts before the axis, cut the start to match startDate
    const actualStart = cellStart < startDate ? startDate : cellStart;
    // If the week ends after the axis, cut the end to match endDate
    const actualEnd = cellEnd > endDate ? endDate : cellEnd;

    // 3. Calculate span only for the visible portion
    const spanMs = actualEnd - actualStart;
    const spanDays = spanMs / dayMs;

    // Skip rendering if the cell is completely outside the visible range
    if (spanDays <= 0) return;

    const cell = document.createElement("div");
    cell.className = "time-axis-cell" + (isprintView ? " printview" : "") + extraClassCell;
    
    const isWeekend = d.getUTCDay() === 0 || d.getUTCDay() === 6;
    const isHoliday = holidays.some(h => h.date.toDateString() === d.toDateString());

    if (withWeekends && isWeekend) {
      cell.classList.add("weekend");
    }

    if (withHolidays && isHoliday) {
      cell.classList.add("holiday");
    }

    cell.style.width = `${spanDays * widthPerDay}px`;
    cell.textContent = format(d, i);
    line.appendChild(cell);
  });
  
  return line;
}

export function daysBetween(date1, date2, rounded=true) {
  const msPerDay = 1000 * 60 * 60 * 24;
  const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
  let bet = Math.floor(Math.abs(utc2 - utc1) / msPerDay);
  return (rounded && bet < 7) ? 7 : bet;
}


export function isHttpSuccess(xhr) {
    return xhr.status >= 200 && xhr.status < 300;
}

export function sendRequest(url, params, onSuccess, onFailure, method='POST') {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url, true); // async

  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('Accept', 'application/json');
  var token = document.querySelector('meta[name="csrf-token"]').content;
  xhr.setRequestHeader('X-CSRF-Token', token);

  xhr.onload = function() {
    let response = {};
    let lesbar = true;
    try { response = JSON.parse(xhr.responseText); } catch(e) { lesbar = false; }
    if (typeof response !== 'object' || response === null) { response = {}; lesbar = false; }
    if (isHttpSuccess(xhr)) {
      onSuccess(response);
    } else {
      // Ohne diesen Ersatztext kam beim Nutzer ein alert(undefined) an: die
      // Aufrufer melden response.error, und laeuft der Server im
      // Development-Modus, liefert er bei einem Fehler eine HTML-Seite statt
      // JSON - dann bleibt response leer. Siehe TIM-54.
      if (!response.error) {
        response.error = lesbar
          ? 'Der Server hat die Anfrage abgelehnt (Status ' + xhr.status + ').'
          : 'Der Server hat mit Status ' + xhr.status + ' geantwortet; die Meldung war nicht lesbar. Details stehen im Server-Log.';
      }
      onFailure(response);
    }
  };

  xhr.onerror = function() {
    onFailure({ error: 'Netzwerkfehler' });
  };

  console.log("sendRequest params=" + JSON.stringify(params));
  xhr.send(JSON.stringify(params));
}

export function getBookings(project, bookings) {
	if (!bookings || bookings.length === 0) {
		return []
	}
	
	if (project.id === 0) {
		return bookings
	}
	
	return bookings.filter(b => b.project_id === project.id)	
}

export function pixel2int(px) {
	return parseInt(px.slice(0, -2))
}

export function box2int(box) {
	return Object.fromEntries(Object.entries(box).map(([key, value]) => [key, pixel2int(value)]));
}

// Die Kategorien der Unterprojekte (TIM-73). Sie stammen aus dem Ruby-Modell
// (Project::CATEGORIES) und werden beim Start als data-Attribut uebergeben, damit
// es sie nur an einer Stelle gibt. Reihenfolge im Hash = Reihenfolge im Planer.
export const CATEGORIES = (() => {
  try {
    return JSON.parse(document.getElementById('app')?.dataset.categories || '{}')
  } catch {
    return {}
  }
})()

// Ein Leistungsbereich wird gespiegelt - der Spiegel muss also in einen
// Abschnitt des Hauptprojekts passen. Faellt die Buchung in eine Pause, wird
// wie beim Projektzeitraum gefragt, ob angepasst werden soll. Fuer die uebrigen
// Kategorien gibt es nichts zu pruefen: sie werden nicht gespiegelt und duerfen
// ueber Pausen hinweg laufen.
//
// Rueckgabe wie validateProjectDuration, zusaetzlich das Hauptprojekt selbst -
// angepasst werden muss ja dieses, nicht der Bereich.
export function validateParentDuration(project, projects, bstart, bend) {
  if (!project?.parent_id || project.category !== DERIVING_CATEGORY) return [true, false, null, null, null, null]

  const haupt = projects.find(p => Number(p.id) === Number(project.parent_id))
  if (!haupt) return [true, false, null, null, null, null]

  const [ok, aendern, newpstart, newpend, nachher] = validateProjectDuration(haupt, bstart, bend, haupt.name)
  return [ok, aendern, newpstart, newpend, nachher, haupt]
}

// Unterprojekte stehen direkt unter ihrem Hauptprojekt, nach Kategorie
// gruppiert und darin alphabetisch. Projekte ohne Unterprojekte behalten die
// bisherige rein alphabetische Reihenfolge.
//
// Bewusst ohne feste Annahme ueber die Tiefe: die Beschraenkung auf eine Ebene
// haelt das Modell (Project#nur_eine_ebene), nicht die Anzeige.
export function sortProjects(projects) {
    const nachName = (a, b) => a.name.localeCompare(b.name);
    const haupt  = projects.filter(p => !p.parent_id).sort(nachName);
    const kinder = projects.filter(p => p.parent_id);
    if (kinder.length === 0) return haupt;

    const reihenfolge = Object.keys(CATEGORIES);
    const sortiert = [];
    for (const p of haupt) {
      sortiert.push(p);
      const meine = kinder.filter(k => k.parent_id === p.id);
      for (const kat of reihenfolge) {
        sortiert.push(...meine.filter(k => k.category === kat).sort(nachName));
      }
      // Unbekannte Kategorie (etwa nach einer Umbenennung im Code): ans Ende,
      // damit ein Unterprojekt nie unsichtbar wird.
      sortiert.push(...meine.filter(k => !reihenfolge.includes(k.category)).sort(nachName));
    }
    return sortiert;
}

export function popupProjectsList(projects) {
	return projects.filter(p => p.status !== 1).sort((a, b) => a.name.localeCompare(b.name));
}

export function userFromRow(users, row) {
  //console.log("row id=" + row.id);
  let s = row.id.split('-');
  if (s.length < 2) {
	return [null, null]
  }
  let uid = s[1];
  return [users.find(u => u.id.toString() === uid), parseInt(s[0])];
}

/*
export function getResourceRange(b, users, timesheet) {
	let timesheet_rect = timesheet.getBoundingClientRect();
	let starty = b.y + timesheet_rect.y;

	let sel_range = [];
	let selected_pid = null;
	let u = null;
	document.querySelectorAll(".resource-row").forEach(div => {
		const rect = div.getBoundingClientRect();

		  const intersects = (rect.y >= starty) && rect.y < (starty + b.height);

		  if (intersects) {
			[u, selected_pid] = userFromRow(users, div);
			sel_range.push(u);
		  }
	});
	return [sel_range, selected_pid];
}
*/

export function getResourceRange(b, users, timesheet) {
	let sel_range = [];
	let main_pid = null;
	let u = null;
	
	let startRow = b.y / rowHeight;
	let endRow = startRow + b.height / rowHeight;
	//console.log("startRow=" + startRow + " endRow=" + endRow)
	let k = 0;
	document.querySelectorAll(".resource-row").forEach(div => {
		//console.log("div id=" + div.id)
		const rect = div.getBoundingClientRect();
		let [u, selected_pid] = userFromRow(users, div);
		
		//console.log("k=" + k)
		if (k >= startRow && k < endRow && u) {
      if (selected_pid !== null) {
			  main_pid = selected_pid
		  }

			//console.log("found resource=" + JSON.stringify(u) + " selected_pid=" + selected_pid)
			sel_range.push(u);
		}
		k++
	});
	//console.log("sel_range=" + JSON.stringify(sel_range) + " main_pid=" + main_pid)

	return [sel_range, main_pid];
}

export function snapDim(length, unit) {
  return Math.round(length / unit) * unit;
}

export function setDim(rect, l, t, w, h, unitw, unith) {

  let sl = snapDim(l, unitw);
  let st = snapDim(t, unith);
  let sw = snapDim(w, unitw);
  let sh = snapDim(h, unith);
  rect.style.left = `${sl}px`;
	rect.style.top = `${st}px`;
	rect.style.width = `${sw}px`;
	rect.style.height = `${sh}px`;

  console.log("rect.style.left=" + sl + " rect.style.top=" + st + " rect.style.width=" + sw + " rect.style.height=" + sh);
}

export function getProjectBookings(bookings, p) {
	console.log("p=" + JSON.stringify(p))
	return (p.id === 0) ? bookings : bookings.filter(b => b.project_id === p.id);		
}


export function getUserBookings(pid2pnames, bookings, p, u, isprintView, projects = null) {
  // Fremdbuchungen - was die Person anderswo tut - erscheinen im Hauptprojekt
  // und in Leistungsbereichen, weil dort die Frage "kann ich die Person hier
  // einplanen" gestellt wird. In einer Unterkunft ist sie ohne Belang: wer
  // dort wohnt, wohnt dort, egal wo er tagsueber arbeitet (TIM-73).
  const zeigtFremde = !p.category || p.category === DERIVING_CATEGORY

  // Im Hauptprojekt keine Balken aus den eigenen Bereichen: was dort an Arbeit
  // laeuft, steht hier ohnehin als abgeleitete Buchung, und eine Unterkunft
  // sagt nichts darueber aus, ob die Person eingeplant werden kann. In einem
  // Leistungsbereich bleiben sie stehen - dort ist "steckt schon woanders im
  // selben Projekt" genau die Frage.
  const ausEigenemBereich = (b) => {
    if (p.parent_id) return false
    const bp = projects?.find(x => Number(x.id) === Number(b.project_id))
    return !!bp && Number(bp.parent_id) === Number(p.id)
  }

  let bs = bookings
    .filter(b => isUserBooking(p, u, b))
    .filter(b => b.project_id === p.id
              || (zeigtFremde && !ausEigenemBereich(b) && isBookingInProject(p, b, projects)))
    .filter(b => (isprintView ? p.id === b.project_id : true))

  // Quelle und Spiegel sind dieselbe Tatsache und duerfen nie zusammen in einer
  // Zeile stehen - sonst liegen zwei Balken fuer denselben Zeitraum
  // uebereinander. Es gilt die, die in DIESER Zeile zu Hause ist; ist es keine
  // von beiden (etwa im Nachbarbereich, wo beide nur Fremdbuchung sind), gilt
  // die Quelle - sie nennt den Bereich, in dem tatsaechlich gearbeitet wird
  // (TIM-74).
  const vorhanden = new Set(bs.map(b => b.id))
  bs = bs
    .filter(b => {
      if (!b.derived_from_id) {
        return !bs.some(x => x.derived_from_id === b.id && x.project_id === p.id)
      }
      return b.project_id === p.id || !vorhanden.has(b.derived_from_id)
    })
    .map(b => prepTask(pid2pnames, p, u, b, bookings))

  return  Array.from(bs);
}

export function removeLastn(str, n) {
  console.log("str.substring(0, str.length - 3)=" + str.substring(0, str.length - 3));
  return str.substring(0, str.length - 3);
}

export function getProjectFromRow(e, projects) {
  let row = e.target.closest(".resource-row");
  if (!row || !row.id) {
	return null;
  }
  console.log("getProjectFromRow id=" + row.id)
  let id_split = row.id.split('-');
  if (id_split.length < 2) {
	return null;
  }
  let pid = parseInt(id_split[0]);
  if (isNaN(pid)) {
	return null;
  }
  return projects.find(p => p.id === pid) ?? null;

}


export function formatDateDDMMYYYY(date, sep='-') {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}${sep}${month}${sep}${year}`;
}

export function formatDateYYMMDD(date, sep = '-') {
  const day = String(date.getDate()).padStart(2, "0");            // Day (Local)
  const month = String(date.getMonth() + 1).padStart(2, "0");     // Month (0-indexed)
  
  // Get 4-digit year, convert to string, and take last 2 characters
  const year = String(date.getFullYear()).slice(-2);              

  return `${year}${sep}${month}${sep}${day}`;
}

// Pixelposition auf der Zeitachse -> Kalendertag als ISO.
// Das Achsen-Raster liegt seit TIM-36 auf UTC-Mitternacht, passend zu scaleUtc
// und zu fromIso/toIso im Modell.
export function xToIso(x, xpos) {
	return toIso(x.invert(xpos));
}

export function scrollToToday(x, view) {
  scrollToDate(x, new Date(), view);
};

export function scrollToDate(x, d, view) {
  let offset = getWidthPerDay(false, view.zoomWidthPerDay) * 1.7
  const targetX = cleanx(x, d) - offset;
  document.getElementById('main-scroll-area').scrollLeft = Math.max(0, targetX);
};

export function applyResoureFilter(resourceFilter, p, u) {
  return resourceFilter.visible.has(u.id);
}

/**
 * Die sichtbaren Personen je Projekt aus der gespeicherten Regel ausrechnen.
 * Der Aufrufer muss das bei jeder Buchungsaenderung neu anstossen, sonst altert
 * die Liste (TIM-17) — in D3Planner haengt es deshalb an einem computed.
 */
export function computeResourceFilter(view, projects, users, bookings) {
  let resourceFilter = {};
  for (const p of projects) {
    const filter = view.getResourceFilter(p.id);
    resourceFilter[p.id] = { filter, visible: evaluateFilter(filter, p, users, bookings, projects) };
  }
  return resourceFilter;
}

export function removeSelections() {
  document.querySelectorAll(".editable").forEach(t => t.classList.remove("editable"));
  document.querySelectorAll(".highlight-bar").forEach(t => t.classList.remove("highlight-bar"));
}

export async function generateTiledPdf(
  project,
  timesheetEl,
  cornerEl,
  sidebarEl,
  html2canvas,
  jsPDF,
  zoomWidthPerDay,
  printStart,
  printEnd,
  onProgress,
) {

// 1. CREATE A WRAPPER THAT IS "OFF-SCREEN" BUT VISIBLE TO THE BROWSER
  const offscreenContainer = document.createElement('div');
  Object.assign(offscreenContainer.style, {
    position: 'absolute',
    top: '0',
    left: '-10000px',        // Move it way off-screen
    width: 'max-content',
    visibility: 'visible',   // MUST be visible for html2canvas
    pointerEvents: 'none'    // Prevent user interaction
  });
  document.body.appendChild(offscreenContainer);

  // 2. CLONE AND RESET SCROLL
  const timesheetClone = timesheetEl.cloneNode(true);
  const sidebarClone = sidebarEl.cloneNode(true);
  
  // Ensure the clones themselves aren't holding internal scroll offsets
  timesheetClone.scrollLeft = 0;
  timesheetClone.scrollTop = 0;
  sidebarClone.scrollTop = 0;

  offscreenContainer.appendChild(sidebarClone);
  offscreenContainer.appendChild(timesheetClone);

  const pdf = new jsPDF("l", "mm", "a4");

  // --- MARGINS ---
  const marginL = 10;
  const marginR = 10;
  const marginT = 20;
  const marginB = 10;

  const pageWidthMm = pdf.internal.pageSize.getWidth();
  const pageHeightMm = pdf.internal.pageSize.getHeight();

  const pxToMm = (px) => (px * 25.4) / 96;
  const mmToPx = (mm) => (mm * 96) / 25.4;

  const scaleFactor = 2;

  const sidebarWidthMm = pxToMm(sidebarEl.offsetWidth);
  const cornerHeightMm = pxToMm(cornerEl.offsetHeight);

  // --- 1. PRE-RENDER THE LOGO (SMALLER SCALE) ---
  const cornerCanvas = document.createElement('canvas');
  const ctx = cornerCanvas.getContext('2d');
  const logoImg = cornerEl.querySelector('img');

  const scale = scaleFactor;
  cornerCanvas.width = cornerEl.offsetWidth * scale;
  cornerCanvas.height = cornerEl.offsetHeight * scale;

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, cornerCanvas.width, cornerCanvas.height);

  if (logoImg && logoImg.complete) {
      const aspectRatio = logoImg.naturalWidth / logoImg.naturalHeight;
      
      // SCALE: Reduced to 35% of container width
      const destWidth = (cornerEl.offsetWidth * 0.35) * scale; 
      const destHeight = destWidth / aspectRatio;
      
      // POSITIONING: 8px padding for a cleaner look
      const padding = 8 * scale;
      
      // Optional: High-quality scaling
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      
      ctx.drawImage(logoImg, padding, padding, destWidth, destHeight);
  }

  const cornerImg = cornerCanvas.toDataURL("image/jpeg", 0.95);

  // --- TRUE dimensions (NO -1 hacks) ---
  // Use the explicitly set style.width instead of scrollWidth: tasks positioned
  // after the print end date overflow the container (overflow: visible), which
  // inflates scrollWidth and causes the PDF to include pages beyond the date range.
  const totalWidth = parseFloat(timesheetEl.style.width) || timesheetEl.scrollWidth;
  const totalHeight = cornerEl.scrollHeight + sidebarEl.scrollHeight;

  // --- USABLE GRID WIDTH ---
  const usableGridWidthMm =
    pageWidthMm - marginL - marginR - sidebarWidthMm;

  const rawPxGridPageWidth = mmToPx(usableGridWidthMm);

  // Snap to full WEEK width (7 days), damit der Seitenumbruch immer auf einen
  // Montag fällt (Druckbereich der Modi 0/1 startet auf einem Montag) und so eine
  // volle Woche pro Seite bleibt statt mitten in der Woche zu brechen.
  const widthPerDayPx = getWidthPerDay(true, zoomWidthPerDay);
  const weekWidthPx = widthPerDayPx * 7;

  const pxGridPageWidth = Math.max(
    weekWidthPx,
    Math.floor(rawPxGridPageWidth / weekWidthPx) * weekWidthPx
  );

  // --- USABLE HEIGHT ---
  const usableHeightMm = pageHeightMm - marginT - marginB;
  const pxPageHeight = Math.floor(mmToPx(usableHeightMm));

  const cols = Math.ceil(totalWidth / pxGridPageWidth);
  const rows = Math.ceil(totalHeight / pxPageHeight);
  const totalSteps = cols * rows;

  let currentStep = 0;

  await new Promise(r => setTimeout(r, 100));

  for (let y = 0; y < totalHeight; y += pxPageHeight) {
    const remainingHeight = totalHeight - y;
    const capturedPxHeight = Math.min(
      pxPageHeight,
      remainingHeight
    );

    if (capturedPxHeight <= 1) continue;

    const sliceHeightMm = pxToMm(capturedPxHeight);

    // --- SIDEBAR SLICE ---
    const sidebarSliceCanvas = await html2canvas(sidebarClone, {
        scale: scaleFactor,
        useCORS: true,
        width: sidebarEl.offsetWidth,
        height: capturedPxHeight,
        x: 0,
        y: y,
        scrollX: 0,
        scrollY: 0, // The clone isn't scrolled, so 0 is absolute
    });

    const sidebarSliceImg = sidebarSliceCanvas.toDataURL("image/jpeg", 0.95);

    for (let x = 0; x < totalWidth; x += pxGridPageWidth) {
      const remainingWidth = totalWidth - x;
      const capturedPxWidth = Math.min(pxGridPageWidth, remainingWidth);
      if (capturedPxWidth <= 1) continue;

      // --- DIRECT CAPTURE METHOD (Faster & More Reliable) ---
      const canvas = await html2canvas(timesheetClone, {
          scale: scaleFactor,
          useCORS: true,
          logging: false,    // Clean up console
          width: capturedPxWidth + 2,
          height: capturedPxHeight,
          x: x,
          y: y,
          scrollX: 0, 
          scrollY: 0,
          backgroundColor: '#ffffff' // Ensure no transparency
      });
      const imgData = canvas.toDataURL("image/jpeg", 0.85);

      if (currentStep > 0) pdf.addPage();
      currentStep++;

      // --- DRAW CORNER ---
      pdf.addImage(cornerImg, "JPEG", 0, 0, sidebarWidthMm, cornerHeightMm);

      // --- DRAW SIDEBAR ---
      pdf.addImage(sidebarSliceImg, "JPEG", marginL, marginT + cornerHeightMm, sidebarWidthMm, sliceHeightMm);

      pdf.addImage(imgData, "JPEG", marginL + sidebarWidthMm, marginT, pxToMm(capturedPxWidth), sliceHeightMm);

      // --- HEADER TEXT ---
      pdf.setFontSize(10);
      pdf.setTextColor(100);

      let title = (project.altname ? project.altname + " · " : "") + project.name + (project.description ? " · " + project.description : "")
      pdf.setFont("helvetica", "bold");
      pdf.text(title, marginL + sidebarWidthMm, marginT - 5);

      pdf.setFont("helvetica", "normal");
      pdf.text("Personalplan Ausgabedatum ", marginL + sidebarWidthMm, marginT + 2);

      pdf.setFont("helvetica", "bold");
      pdf.text(formatDateDDMMYYYY(new Date(), "."), marginL + sidebarWidthMm + 51, marginT + 2);

      if (printStart && printEnd) {
        pdf.setFont("helvetica", "normal");
        pdf.text("Zeitraum:", marginL + sidebarWidthMm + 75, marginT + 2);
        pdf.setFont("helvetica", "bold");
        pdf.text(`${formatDateDDMMYYYY(printStart, ".")} – ${formatDateDDMMYYYY(printEnd, ".")}`, marginL + sidebarWidthMm + 97, marginT + 2);
      }

      // --- PAGE NUMBER ---
      const pageText = `${currentStep} / ${totalSteps}`;
      const textWidth =
        (pdf.getStringUnitWidth(pageText) *
          pdf.getFontSize()) /
        pdf.internal.scaleFactor;

      pdf.setFont("helvetica", "normal");
      pdf.setTextColor(50);

      pdf.text(
        pageText,
        pageWidthMm - marginR - textWidth,
        pageHeightMm - marginB / 2,
      );

      pdf.text(
        "Team",
        marginR + 2.7,
        61,
      );

      if (onProgress) {
        onProgress((currentStep / totalSteps) * 100);
      }
    }
  }

  const fileName = project.name + " Personalplan TI " + formatDateYYMMDD(new Date(), "");

  pdf.save(`${fileName}.pdf`);
}


export function getWeekBounds(startDateStr, endDateStr) {
  // Helper to parse DD-MM-YYYY into a Date object
  
  const parseDate = (str) => {
    const [day, month, year] = str.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  // Helper to format Date object back to DD-MM-YYYY
  const formatDate = (date) => {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    return `${d}-${m}-${y}`;
  };

  let start = parseDate(startDateStr);
  let end = parseDate(endDateStr);

  // 1. Find the earliest Monday
  // getDay(): Sun=0, Mon=1, Tue=2...
  // If day is 0 (Sun), we need to go back 6 days.
  // If day is 1 (Mon), we go back 0 days.
  const startDay = start.getDay();
  const diffToMonday = startDay === 0 ? 6 : startDay - 1;
  start.setDate(start.getDate() - diffToMonday);

  // 2. Find the latest Sunday
  // If day is 0 (Sun), we stay.
  // If day is 1 (Mon), we add 6 days.
  const endDay = end.getDay();
  const diffToSunday = endDay === 0 ? 0 : 7 - endDay;
  end.setDate(end.getDate() + diffToSunday);

  return {
    earliestMonday: formatDate(start),
    latestSunday: formatDate(end)
  };
}

let scrollVelocity = 0;
let isAutoScrolling = false;
let containerRef = null;

function step() {
  if (!isAutoScrolling) return;

  if (scrollVelocity === 0 || !containerRef) {
    isAutoScrolling = false;
    return;
  }

  containerRef.scrollLeft += scrollVelocity;

  requestAnimationFrame(step);
}

export function startAutoScroll(container, velocity) {
  containerRef = container;
  scrollVelocity = velocity;

  if (!isAutoScrolling) {
    isAutoScrolling = true;
    requestAnimationFrame(step);
  }
}

export function updateAutoScroll(velocity) {
  scrollVelocity = velocity;
}

export function stopAutoScroll() {
  isAutoScrolling = false;
  scrollVelocity = 0;
}

export function handleAutoScroll(e) {
  console.log("window.__POINTER_DOWN__=" + window.__POINTER_DOWN__)
  const container = document.querySelector('.main-scroll-area');
  if (!container) return;

  if (!window.__POINTER_DOWN__) {
    stopAutoScroll();
    return;
  }

  const rect = container.getBoundingClientRect();
  const clientX = e.touches ? e.touches[0].clientX : e.clientX;

  const EDGE = 60;
  const MAX_SPEED = 40;

  const leftEdge  = Math.max(rect.left, 0);
  const rightEdge = Math.min(rect.right, window.innerWidth);

  if (clientX < leftEdge + EDGE) {
    const distance = leftEdge + EDGE - clientX;
    const velocity = -Math.min(MAX_SPEED, distance * 0.5);
    startAutoScroll(container, velocity);
  } 
  else if (clientX > rightEdge - EDGE) {
    const distance = clientX - (rightEdge - EDGE);
    const velocity = Math.min(MAX_SPEED, distance * 0.5);
    startAutoScroll(container, velocity);
  } 
  else {
    stopAutoScroll();
  }
}

export function positionTodayLine(id, x, today) {
	const todayLine = document.getElementById(id);
  today.setHours(0, 0, 0, 0);
	todayLine.style.left = `${cleanx(x, today)}px`;
}

function filterBookingForDay(b, day) {
  return b.start <= day && day <= b.end;
}

// `day` ist ein ISO-Tag ("yyyy-mm-dd"), gebildet mit toIso - auch aus dem
// Achsen-Raster, das seit TIM-36 ebenfalls auf UTC-Mitternacht liegt.
// visibleUserIds ist die Menge der Personen, die im Projekt tatsaechlich eine
// Zeile bekommen. Ohne sie zaehlte der Zaehler auch Buchungen von Leuten, die
// gerade weggefiltert oder deaktiviert sind - die Zahl stand dann ueber einer
// leeren Flaeche (TIM-71). Fehlt der Parameter, bleibt es beim alten Verhalten.
export function countBookingsForDay(view, project, bookings, day, visibleUserIds = null) {
	const sichtbare = visibleUserIds
		? bookings.filter(b => visibleUserIds.has(b.user_id))
		: bookings
	let count = sichtbare.filter(b => filterBookingForDay(b, day)).length
	if (project.id === 0) {
		// Die Urlaubszeile zeigt, wie viele noch frei sind. Die Bezugsgroesse
		// muss dieselbe Menge sein, aus der gezaehlt wurde, sonst wird die Zahl
		// falsch, sobald gefiltert ist.
		const basis = visibleUserIds ? visibleUserIds.size : view.countActiveUsers
		count = basis - count
	}
	return count
}

export function isCloseToMultiple(x, m, eps) {
  let r = x % m;
  return Math.min(r, m - r) < eps;
}

// Prüft, ob die Buchung [bstart, bend] den Projektzeitraum sprengt. Alles ISO.
// Rückgabe: [ok, extendsProjectDuration, newpstartIso, newpendIso].
// Dieselbe Zusammenfassung wie ProjectPeriod.normalize auf dem Server: Pausen
// unter MIN_PAUSE_DAYS verschwinden, Ueberlappendes verschmilzt. Beide Seiten
// muessen zum selben Ergebnis kommen, sonst zeigt der Dialog etwas anderes an,
// als hinterher gespeichert wird.
export const MIN_PAUSE_DAYS = 7;

export function normalizePeriods(periods) {
  const sorted = periods
    .map(p => ({ start: p.start, end: p.end }))
    .sort((a, b) => a.start.localeCompare(b.start));

  const out = [];
  for (const p of sorted) {
    const last = out[out.length - 1];
    // Achtung: die Pause ist (naechster.start - voriger.end - 1) Tage lang.
    if (last && daysBetweenIso(last.end, p.start) <= MIN_PAUSE_DAYS) {
      if (p.end > last.end) last.end = p.end;
    } else {
      out.push({ ...p });
    }
  }
  return out;
}

// Prüft, ob die Buchung [bstart, bend] die Abschnitte des Projekts veraendert,
// und fragt gegebenenfalls nach. Rückgabe:
// [ok, extendsProjectDuration, newpstartIso, newpendIso, newPeriods].
export function validateProjectDuration(project, bstart, bend, uebergeordnet = null) {
  const periods = projectPeriods(project);
  const nachher = normalizePeriods([...periods, { start: bstart, end: bend }]);

  const unveraendert = periods.length === nachher.length &&
    periods.every((p, i) => p.start === nachher[i].start && p.end === nachher[i].end);

  const newpstart = nachher.length ? nachher[0].start : project.start;
  const newpend   = nachher.length ? nachher[nachher.length - 1].end : project.end;

  if (unveraendert) {
    return [true, false, newpstart, newpend, nachher];
  }

  // Der Text nennt, was tatsaechlich passiert - verlaengern, neuer Abschnitt
  // oder Pause schliessen sind fuer den Nutzer drei verschiedene Dinge.
  //
  // Geht es um das uebergeordnete Projekt, nennt der Text es beim Namen und
  // sagt, warum es ueberhaupt betroffen ist: gebucht wird ja im Bereich, die
  // Buchung erscheint aber auch oben (TIM-73). Ohne den Zusatz las sich die
  // Frage, als ginge es um den Bereich selbst.
  const einleitung = uebergeordnet
    ? `Diese Buchung erscheint auch in ${uebergeordnet}, weil Leistungsbereiche dorthin übernommen werden. `
    : "";
  const wessen = uebergeordnet ? `der Laufzeit von ${uebergeordnet}` : "des Projektzeitraums";
  const wo     = uebergeordnet ? `in ${uebergeordnet} ` : "";

  let frage;
  if (nachher.length > periods.length) {
    const neu = nachher.find(n => !periods.some(p => p.start === n.start && p.end === n.end));
    const abstand = periods.length
      ? Math.abs(daysBetweenIso(periods[periods.length - 1].end, bstart)) - 1
      : 0;
    // Zwischen zwei bestehenden Abschnitten heisst: in einer Pause. Das ist etwas
    // anderes als "nach dem Ende", und beim uebergeordneten Projekt ist es der
    // haeufige Fall - "22 Tage ausserhalb der Laufzeit" waere dort schlicht
    // falsch, das Projekt laeuft ja drumherum.
    const inPause = periods.length > 1 &&
                    neu.start > periods[0].start &&
                    neu.end   < periods[periods.length - 1].end;

    frage = uebergeordnet
      ? einleitung + (inPause
          ? `Sie liegt in einer Pause von ${uebergeordnet}. `
          : "Sie liegt " + abstand + " Tage außerhalb " + wessen + ". ") +
        "Es entsteht " + wo + "ein neuer Abschnitt vom " + toGerman(neu.start) +
        " bis " + toGerman(neu.end) + ". Möchten Sie das?"
      : "Diese Buchung liegt " + abstand + " Tage außerhalb des Projektzeitraums. " +
        "Es entsteht ein neuer Projektabschnitt vom " + toGerman(neu.start) +
        " bis " + toGerman(neu.end) + ". Möchten Sie das?";
  } else if (nachher.length < periods.length) {
    frage = uebergeordnet
      ? einleitung + `Sie schließt eine Pause in ${uebergeordnet}. Der Abschnitt läuft dann vom ` +
        toGerman(newpstart) + " bis " + toGerman(newpend) + ". Möchten Sie das?"
      : "Diese Buchung schließt eine Pause im Projekt. Der Projektabschnitt läuft dann vom " +
        toGerman(newpstart) + " bis " + toGerman(newpend) + ". Möchten Sie das?";
  } else {
    frage = uebergeordnet
      ? einleitung + `Sie verlängert die Laufzeit von ${uebergeordnet} auf ` +
        toGerman(newpstart) + " bis " + toGerman(newpend) + ". Möchten Sie das?"
      : "Diese Buchung verlängert den Projektzeitraum auf " + toGerman(newpstart) +
        " bis " + toGerman(newpend) + ". Möchten Sie das?";
  }

  if (!window.confirm(frage)) {
    return [false, true];
  }
  return [true, true, newpstart, newpend, nachher];
}

// Nächstgelegene Buchung derselben Person, die [startIso, endIso] überschneidet (excludeId ausgenommen).
// origStartIso/origEndIso = aktueller Zeitraum der bearbeiteten Buchung (bestimmt Richtung/Seite).
// bookings: Objekte mit {id, user_id, project_id, start, end} (start/end als "yyyy-mm-dd").
// Rückgabe: { booking, isVacation, side } | null.  side: 'right' | 'left' | 'overlap'.
// Wo eine Buchung liegt: in welchem Projektbaum und in welchem Bereich. Ein
// Unterprojekt gehoert zum Baum seines Elternteils; ein Hauptprojekt bildet
// seinen eigenen und hat keine Kategorie.
function bookingScope(projects, projectId) {
  const p = projects.find(x => Number(x.id) === Number(projectId));
  return {
    root: p?.parent_id ?? Number(projectId),
    category: p?.category ?? null,
  };
}

/**
 * Stossen sich zwei Buchungen derselben Person? Nicht mehr die Person allein
 * entscheidet das, sondern wo die beiden liegen (TIM-73):
 *
 *   dieselbe Zeile                    -> Konflikt
 *   gleiche Kategorie, selbes Projekt -> Konflikt (nicht zwei Unterkuenfte)
 *   andere Kategorie, selbes Projekt  -> erlaubt  (Leistung und Unterkunft)
 *   anderes Projekt                   -> Konflikt
 *
 * Urlaub bleibt harter Block und wird vorher abgefangen.
 */
export function kollidiert(projects, aId, bId) {
  if (Number(aId) === Number(bId)) return true;

  const a = bookingScope(projects, aId);
  const b = bookingScope(projects, bId);
  if (Number(a.root) !== Number(b.root)) return true;

  return a.category === b.category;
}

export function findNearestConflict(bookings, userId, excludeId, startIso, endIso, origStartIso, origEndIso, projects = null, targetProjectId = null) {
  const ueberlappend = bookings.filter(b =>
    b.user_id === userId &&
    b.id !== excludeId &&
    !(b.end < startIso || b.start > endIso)
  );
  if (ueberlappend.length === 0) return null;

  // Urlaub (project_id 0) ist harter Block, hat Vorrang - unabhaengig von Baum
  // und Kategorie.
  const vac = ueberlappend.find(b => Number(b.project_id) === 0);
  if (vac) return { booking: vac, isVacation: true, side: 'overlap' };

  // Ohne Projektangaben bleibt es beim bisherigen Verhalten: jede Ueberlappung
  // zaehlt. So bleiben Aufrufer gueltig, die den Bezug nicht kennen.
  const conflicts = (projects && targetProjectId != null)
    ? ueberlappend.filter(b => kollidiert(projects, targetProjectId, b.project_id))
    : ueberlappend;
  if (conflicts.length === 0) return null;

  const classified = conflicts.map(b => {
    let side = 'overlap';
    if (origEndIso != null && b.start > origEndIso) side = 'right';
    else if (origStartIso != null && b.end < origStartIso) side = 'left';
    return { b, side };
  });
  // Nächstgelegene zuerst (nach Startdatum aufsteigend).
  classified.sort((x, y) => (x.b.start < y.b.start ? -1 : x.b.start > y.b.start ? 1 : 0));
  return { booking: classified[0].b, isVacation: false, side: classified[0].side };
}

// Zeitraum so kappen, dass er den Konflikt nicht mehr berührt (Fremdbuchung bleibt unangetastet).
// Rückgabe: [newStartIso, newEndIso] | null (null = nichts sinnvoll Kappbares übrig).
export function clipRangeAgainstConflict(startIso, endIso, conflict, side) {
  if (side === 'right') {
    const newEnd = addDays(conflict.start, -1);
    return newEnd < startIso ? null : [startIso, newEnd];
  }
  if (side === 'left') {
    const newStart = addDays(conflict.end, 1);
    return newStart > endIso ? null : [newStart, endIso];
  }
  return null;
}
